<template>
  <div class="page-comp-customer-feature">
    <div class="details-card-top">
      <span>{{ $t('基本特征') }}</span>
      <jw-space v-if="data.permission == 1">
        <jw-button size="mini" @click="editFeature">
          <template #icon>
            <icon-edit />
          </template>
          {{ $t('修改') }}
        </jw-button>
      </jw-space>
    </div>
    <div class="basic-info" v-if="data.basicFeature?.length > 0">
      <div class="card-edit-body-item" v-for="item in data.basicFeature" :key="item.id">
        <div class="card-edit-body-item-label">{{ item.fieldName }}:</div>
        <div class="card-edit-body-item-content">
          <template v-if="item.fieldValue === 0 || item.fieldValue">
            <template v-if="item.fieldType === 4 || item.fieldType === 5">
              <div class="text" v-if="item?.fieldLabel">{{ item?.fieldLabel }}</div>
              <template v-else>-</template>
            </template>
            <template v-else>
              <div class="text" v-if="item?.fieldValue">{{ item?.fieldValue }}</div>
              <template v-else>-</template>
            </template>
          </template>
          <template v-else>-</template>
        </div>
      </div>
    </div>
    <jw-empty v-else />
    <div class="details-card-top">{{ $t('使用情况') }}</div>
    <div class="basic-info" v-if="data.useCondition.length > 0">
      <div class="card-edit-body-item" v-for="item in data.useCondition" :key="item.id">
        <div class="card-edit-body-item-label">{{ item.fieldName }}:</div>
        <div class="card-edit-body-item-content">
          <template v-if="item.fieldValue === 0 || item.fieldValue">
            <template v-if="item.fieldType === 4 || item.fieldType === 5">
              <div class="text" v-if="item?.fieldLabel">{{ item?.fieldLabel }}</div>
              <template v-else>-</template>
            </template>
            <template v-else>
              <div class="text" v-if="item?.fieldValue">{{ item?.fieldValue }}</div>
              <template v-else>-</template>
            </template>
          </template>
          <template v-else>-</template>
        </div>
      </div>
    </div>
    <jw-empty v-else />
    <update-feature ref="updateFeatureRef" @cb="getFeatureByTypeAndSealId"></update-feature>
  </div>
</template>

<script setup>
import { inject, onMounted, reactive, ref } from 'vue';
import { salesService } from '@/api/';
import { Message } from '@arco-design/web-vue';
import UpdateFeature from '@/views/sales-service/components/update-feature/index.vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const updateFeatureRef = ref();
const data = reactive({
  permission: inject('detailParams')?.permission,
  id: inject('detailParams')?.id,
  productLine: inject('detailParams')?.productLine,
  basicFeature: [], //基本特征数据列表
  useCondition: [] //使用情况数据列表
});
onMounted(() => {
  console.log(12333, '@@#@');
  getFeatureByTypeAndSealId();
});
// 获取客户特征值
const getFeatureByTypeAndSealId = async () => {
  try {
    const params = {
      id: data.id,
      type: data.productLine
    };
    data.basicFeature = [];
    const json = await salesService.getFeatureByTypeAndSealId(params);
    if (!json.error) {
      console.log(35, json.result);
      data.basicFeature = json.result?.base;
      data.useCondition = json.result?.use;
      if (data.basicFeature?.length > 0) {
        data.basicFeature?.forEach((item) => {
          if (item.fieldType === 4) {
            item['fieldLabel'] = item.fieldExt && JSON.parse(item?.fieldExt).find((v) => item.fieldValue === v.value)?.label;
          } else if (item.fieldType === 5) {
            item['fieldLabel'] = [];
            const fieldExt = item.fieldExt && JSON.parse(item?.fieldExt);
            fieldExt.forEach((v) => {
              if (item.fieldValue && item.fieldValue?.split(',').includes(v.value)) {
                item['fieldLabel'].push(v.label);
              }
            });
            item['fieldLabel'] = item['fieldLabel'] && item['fieldLabel']?.join(',');
          }
        });
      }
      if (data.useCondition?.length > 0) {
        data.useCondition?.forEach((item) => {
          if (item.fieldType === 4) {
            item['fieldLabel'] = item.fieldExt && JSON.parse(item?.fieldExt).find((v) => item.fieldValue === v.value)?.label;
          } else if (item.fieldType === 5) {
            // item['fieldLabel'] = item.fieldExt && JSON.parse(item?.fieldExt).find((v) => item.fieldValue && item.fieldValue.split(',').includes(v.value))?.label;
            item['fieldLabel'] = [];
            const fieldExt = item.fieldExt && JSON.parse(item?.fieldExt);
            fieldExt.forEach((v) => {
              if (item.fieldValue && item.fieldValue?.split(',').includes(v.value)) {
                item['fieldLabel'].push(v.label);
              }
            });
            item['fieldLabel'] = item['fieldLabel'] && item['fieldLabel']?.join(',');
          }
        });
      }
    } else {
      Message.error(json.error?.msg || t('操作失败'));
    }
  } catch (e) {
    console.log(e);
    Message.error(e.message || e.statusText || t('操作失败'));
  }
};
// 编辑客户特征
const editFeature = () => {
  const params = {
    id: data.id,
    type: data.productLine,
    basicFeature: data.basicFeature,
    useCondition: data.useCondition
  };
  updateFeatureRef.value.open(params);
};

defineExpose({ getFeatureByTypeAndSealId });
</script>
<style scoped lang="less">
@import './index.less';
</style>
